import React, { useState, useMemo } from "react";
import "./listview.css";

const normalize = (s) => (s ?? "").toString().trim().toLowerCase();

const ListView = ({ items, sellerName }) => {
  if (!items || items.length === 0) {
    return <p>Nu există rezultate de afișat.</p>;
  }

  return (
    <div className="list-container">
      {items.map((item, index) => (
        <ExpandableCard key={index} item={item} sellerName={sellerName} />
      ))}
    </div>
  );
};

const ExpandableCard = ({ item, sellerName }) => {
  const [expanded, setExpanded] = useState(false);
  const { image_url, name, main_offer: main, other = [] } = item;

  const mapAvailability = (value) => {
    const availabilityMap = {
      in_stock: "În stoc",
      limited_stock_qty: "Stoc limitat",
      out_of_stock: "Stoc epuizat",
    };
    return availabilityMap[value] || value || "-";
  };

  // găsește oferta care corespunde sellerName
  const yourOffer = useMemo(() => {
    if (!sellerName) return null;

    const target = normalize(sellerName);

    const allOffers = [
      ...(main ? [main] : []),
      ...(Array.isArray(other) ? other : []),
    ];

    // 1) match strict (case-insensitive)
    let found = allOffers.find(
      (o) => normalize(o?.Seller) === target
    );

    // 2) fallback: contains (dacă sellerii vin cu extra text)
    if (!found) {
      found = allOffers.find((o) => normalize(o?.Seller).includes(target));
    }

    return found || null;
  }, [sellerName, main, other]);

  if (!main) {
    return (
      <div className="product-card no-offer">
        <div className="product-main-row">
          <div className="product-info">
            <h3 className="product-name">{name}</h3>
            <p className="no-offer-text">
              Nu s-a putut găsi nicio ofertă pentru acest produs.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // dacă nu găsește oferta ta, păstrăm fallback pe main
  const offerToShow = yourOffer ?? main;

  return (
    <div className="product-card">
      <div className="product-main-row">
        {/* Info produs */}
        <div className="product-info">
          {/* image_url && image_url !== "no image" && (
            <img src={image_url} alt={name} className="product-image" />
          ) */}
          <div>
            <h3 className="product-name">{name}</h3>
            {main.Marketplace_Code && (
              <p className="product-code">
                Cod marketplace: <span>{main.Marketplace_Code}</span>
              </p>
            )}
          </div>
        </div>

        {/* Bloc preț */}
        <div className="product-price-block">
          <div className="price-main">
            {main.Sale_Price} {main.Currency}
          </div>

          {/* Prețul tău (din oferta găsită după Seller==sellerName) */}
          <div className="price-label">
            Prețul tău:{" "}
            <strong>
              {offerToShow?.Sale_Price ?? "-"}{" "}
              {offerToShow?.Currency || main.Currency}
            </strong>
            {yourOffer ? null : (
              <span style={{ opacity: 0.8 }}> </span>
            )}
          </div>

          <div className="shipment-tax">
            Cost livrare: {offerToShow?.Shipment_tax || 0} RON
          </div>
        </div>

        {/* Meta */}
        <div className="product-meta">
          <div className="seller-chip">
            Vândut de: <span>{main.Seller ?? "-"}</span>
          </div>
          <div className={`availability-chip ${main.Availability || ""}`}>
            {mapAvailability(main.Availability)}
          </div>

          {other.length > 0 && (
            <button
              className="expand-offers-btn"
              onClick={() => setExpanded((prev) => !prev)}
            >
              <span className={`arrow ${expanded ? "rotated" : ""}`}>▶</span>
              {expanded ? "Ascunde" : "Vezi"} alte {other.length} oferte
            </button>
          )}
        </div>
      </div>

      {/* Oferte alternative */}
      {expanded && other.length > 0 && (
        <div className="other-offers-list">
          {other.map((offer, index) => (
            <div key={index} className="other-offer-row">
              <div className="offer-seller">
                <span className="offer-label">Vânzător</span>
                <span>{offer.Seller}</span>
              </div>

              <div className="offer-price">
                <span className="offer-label">Preț</span>
                <span>
                  {offer.Sale_Price} {offer.Currency || main.Currency}
                </span>
              </div>

              <div className="offer-tax">
                <span className="offer-label">Livrare</span>
                <span>{offer.Shipment_tax || 0} RON</span>
              </div>

              <div className={`offer-availability ${offer.Availability || ""}`}>
                <span className="offer-label">Stoc</span>
                <span>{mapAvailability(offer.Availability)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ListView;
